import {
  DetailedHTMLProps,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';

interface HiddenFileUploadInputProps
  extends Pick<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'accept' | 'onChange' | 'data-testid'
  > {}

export const HiddenFileUploadInput = forwardRef(
  (props: HiddenFileUploadInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { accept, onChange, 'data-testid': testId } = props;

    return (
      <input
        type="file"
        className="hidden"
        onChange={onChange}
        accept={accept}
        data-testid={testId}
        ref={ref}
      />
    );
  }
);
